var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{class:_vm.linkClass,attrs:{"data-testid":"toggle-favorite-off","href":"#"},on:{"click":_vm.favoriteItem}},[_c('div',{class:['star-icon', _vm.iconClass]})])
}
var staticRenderFns = []

export { render, staticRenderFns }